import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reduxForm, Field, SubmissionError} from 'redux-form'
import RenderInputFormGroup from "../Form/RenderInputFormGroup"
import RenderCaptchaInput from '../Form/RenderCaptchaInput'
import {required, email, captcha} from "../Form/rules"
import {handleResetPasswordRequest} from '../../../modules/profile'
import {captchaHashSelector, handleGetCaptchaHash, translationsLocaleSelector} from "../../../modules/app"
import {formatErrorMessage} from "../../../helpers/common"
import ReCAPTCHA from "react-google-recaptcha";
import Axios from 'axios'

class Reset extends Component{
    render() {
        let {handleSubmit, error, submitting, submitSucceeded} = this.props
        let {formatMessage} = this.context

        return (
            <div className="auth-form-wrapper">
                <h1 className="h2 text-center">{formatMessage('Password reset')}</h1>
                <p className="text-center">{formatMessage('Please fill out your email. A link to reset password will be sent there.')}</p>
                <form className="profile-form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "email"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("Email")}:`}
                                id = "email"
                                validate = {[required, email]}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            {/* <Field
                                name = "captcha"
                                type = "captcha"
                                component = {RenderCaptchaInput}
                                label = {`${formatMessage("Verify Code")}:`}
                                id = "captcha"
                                validate = {[required, captcha]}
                                autoComplete="off"
                            /> */}
                            <ReCAPTCHA
                                    sitekey="6Le6bMgUAAAAAPgzmYcBfRJxXpbSnlenhQ1C297N"
                                    onExpired={() => {
                                        console.log('onExpired');
                                        this.props.change('captcha', null)
                                    }}
                                    onErrored={() => {
                                        console.log('onErrored')
                                        this.props.change('captcha', null)
                                    }}
                                    onChange={async(token) => {
                                        try {
                                            const instance = Axios.create();
                                            instance.defaults.headers = {}
                                            const secret= '6Le6bMgUAAAAABLLmFJFhVt75hxHSdqKtheitB0t';

                                            let {data} = await instance.post(`https://www.google.com/recaptcha/api/siteverify?secret=${secret}&response=${token}`, {}, {
                                                // crossDomain: true
                                                headers: {
                                                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                                                }
                                            });
                                        } catch (error) {
                                            this.props.change('captcha', 'yes')
                                        }
                                    }}
                                />
                                <Field 
                                    name = "captcha" 
                                    type="hidden"
                                    validate = {[required]} 
                                    component={RenderInputFormGroup}
                                />
                        </div>
                    </div>

                    {
                        submitSucceeded &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-success">
                                <p>{formatMessage("Check your email for further instructions.")}</p>
                            </div>
                        </div>
                    }

                    {
                        error &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-danger">
                                <p>{formatMessage(error)}</p>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>{formatMessage("Send")}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    static contextTypes = {formatMessage: PropTypes.any}
}


export default connect(
    state => ({
        captchaHash : captchaHashSelector(state),
        locale : translationsLocaleSelector(state),
    }),
    null,
    null,
    {pure: false}
)(reduxForm({
    form: 'reset',
    onSubmit : (values, dispatch) => {
        let {email, captcha} = values
        return handleResetPasswordRequest({email, captcha})
            .catch(error => {
                dispatch(handleGetCaptchaHash())
                throw new SubmissionError({
                    _error : formatErrorMessage(error.message),
                })
            })
    },
    pure: false,
})(Reset))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/Reset.js